import { useSelector } from 'react-redux'
import { Box } from '@homebotapp/hb-react-component-catalog'
import { RootState } from '../../../../../types/rootState'
import { CanRemovePmiDetailsBody } from './CanRemovePmiDetailsBody'
import { CanRemovePmiDetailsHeader } from './CanRemovePmiDetailsHeader'
import { CanRemovePmiDetailsFooter } from './CanRemovePmiDetailsFooter'

export const CanRemovePmiDetails = () => {
  const savings = useSelector<RootState, number | null>(state => state.pmi.totalPmiSavingsInDollars)
  const monthlyPmiPayment = useSelector<RootState, number | null>(state => state.pmi.monthlyPmiPayment)
  const hasSavings: boolean = !!savings && !!monthlyPmiPayment && savings > monthlyPmiPayment

  return (
    <Box
      mt='16'
      mb='12'
      ml='auto'
      mr='auto'
      paddingX='8'
      paddingY='6'
      maxWidth='28rem'
      borderRadius='.75rem'
      // @ts-ignore
      backgroundColor={hasSavings ? 'var(--brand-surface-layer-50)' : ''}
    >
      {hasSavings && <CanRemovePmiDetailsHeader />}
      {hasSavings && <CanRemovePmiDetailsBody />}
      <CanRemovePmiDetailsFooter />
    </Box>
  )
}
